import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, ChevronDown } from 'lucide-react';
import siteData from '@/data/siteData.json';

export const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={siteData.heroImages.main}
          alt="Industrial Automation Background"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1920&q=80';
          }}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 hero-overlay" />
        {/* Noise texture */}
        <div className="absolute inset-0 noise-bg opacity-30" />
      </div>

      {/* Content */}
      <div className="relative z-10 section-container py-20 md:py-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background/10 backdrop-blur-sm border border-background/20 mb-8 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-success animate-pulse" />
            <span className="text-sm font-medium text-background/90">
              Revenda Autorizada
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-background leading-tight mb-6 animate-fade-up animation-delay-100">
            Soluções em
            <br />
            <span className="text-background/80">Automação Industrial</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-background/70 max-w-2xl mb-10 animate-fade-up animation-delay-200">
            {siteData.company.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up animation-delay-300">
            <Button
              size="lg"
              onClick={() => scrollToSection('#produtos')}
              className="btn-hero-primary group"
            >
              Ver Produtos
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('#contato')}
              className="btn-hero-outline"
            >
              Solicitar Orçamento
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 pt-16 border-t border-background/10 animate-fade-up animation-delay-400">
            {siteData.stats.map((stat, index) => (
              <div key={index} className="text-center md:text-left">
                <div className="text-3xl md:text-4xl font-bold text-background mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-background/60">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={() => scrollToSection('#sobre')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-background/60 hover:text-background transition-colors cursor-pointer"
      >
        <span className="text-xs font-medium uppercase tracking-wider">
          Scroll
        </span>
        <ChevronDown className="h-5 w-5 animate-bounce" />
      </button>
    </section>
  );
};
